import React from 'react';
import { Redirect } from 'react-router-dom';
import { CalidadProvider } from './CalidadContext';
import CalidadSelectorCorrida from './CalidadSelectorCorrida';
import CalidadResumen from './CalidadResumen';
import CalidadTable from './CalidadTable';
import CalidadFormModal from './CalidadFormModal';
import { useGeneral } from '../../Context/GeneralContext';
import '../../styles/calidad.css';

function Calidad() {
    const { infoUser } = useGeneral();

    if (infoUser && infoUser.roles && !infoUser.roles.some((r) => r === 'Calidad')) {
        return <Redirect to="/" />;
    }

    return (
        <div className="calidad-view">
            <div className="calidad-head">
                <div className="calidad-head-title">
                    <h1 className="calidad-head-titulo">Calidad</h1>
                </div>
                <div className="calidad-head-filters">
                    <div className="calidad-head-filters-card">
                        <CalidadSelectorCorrida />
                    </div>
                </div>
            </div>

            <div className="calidad-body">
                <CalidadResumen />
                <CalidadTable />
            </div>

            <CalidadFormModal />
        </div>
    );
}

export default function CalidadProviderComp() {
    return (
        <CalidadProvider>
            <Calidad />
        </CalidadProvider>
    );
}
